var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"id":"alert","show":this.visibleSecondsLeft,"dismissible":"","fade":"","variant":this.type},on:{"dismiss-count-down":this.countDownChanged}},[_vm._v(" "+_vm._s(this.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }